import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { fetchDetailsQuote } from '../actions/quotes'
import { setBreadcrumb } from '../actions/breadcrumb'

import { DROPOFF, COMPUTED, RETURNS } from '../assets/constant'
import { isEmpty ,stringEmpty } from '../assets/utils'

import DropoffSelected from './DropoffSelected'

var interval = 0

class Dropoff extends React.Component {

  constructor(props) {
    super()
    this.props = props
    this.initDropoff = this.initDropoff.bind(this)
    if (this.props.dropoff == undefined) {
      this.props.fetchDetailsQuote(shipback_id, "dropoff", this.props.user_token)
    }
  }

  componentWillMount() {
    interval = setInterval(() => { this.initDropoff() }, 300)
  }

  initDropoff() {
    if (this.props.dropoff != undefined && this.props.dropoff.state == COMPUTED && this.props.dropoff.dropoff_points) {
      for (var i = 0; i < this.props.dropoff.dropoff_points.length ; i++ ) {
        var dropoff_point = this.props.dropoff.dropoff_points[i];
        if (dropoff_point.id == this.props.shipback.dropoff_code) {
          this.props.setDropoff(dropoff_point, i)
          clearInterval(interval)
        }
      }
    } else {
      this.props.setBreadcrumb(RETURNS)
    }
  }

  componentWillUnmount() {
    clearInterval(interval)
  }

  render() {
    if (this.props.dropoff == undefined || this.props.dropoff.state != COMPUTED) {
      return (
        <div className="row dropoff-selected">
          <h2>{I18n.t('shipbacks.modes.dropoffs.fetching.title')}</h2>
        </div>
      )
    } else {
      if (!isEmpty(this.props.selectedDropoff)) {
        return (
          <div className="row dropoff-selected">
            <a data-toggle="modal" href="#edit-dropoff-modal" id="edit-dropoff-button">
              <div className="col-6">
                <h2>{I18n.t('shipbacks.modes.dropoffs.chosen.title')}</h2>
              </div>
              <span className=" pull-right edit">
                {I18n.t('shipbacks.modes.dropoffs.chosen.change')}
              </span>
              <DropoffSelected dropoff={this.props.selectedDropoff} />
            </a>
          </div>
        )
      } else if (this.props.dropoff && this.props.dropoff.dropoff_points) {
        var address = stringEmpty(this.props.shipback.customer.address.line1) + ", " + stringEmpty(this.props.shipback.customer.address.zipcode) + " " + stringEmpty(this.props.shipback.customer.address.city)
        return (
          <div className="row address">
            <div className="col-12">
              <h2>{I18n.t('shipbacks.modes.dropoffs.select.title')}</h2>
            </div>
            <div className="col-12">
              <label>{I18n.t('shipbacks.modes.dropoffs.select.subtitle')}</label>
            </div>
            <div className="col-12 ">
              <span className="value">{address}</span>
            </div>
            <div className="col-12 mt-4">
              <a data-toggle="modal" href="#edit-dropoff-modal" className="search" id="edit-dropoff-button">
                {I18n.t('shipbacks.modes.dropoffs.select.search')}
              </a>
            </div>
          </div>
        )
      } else {
        return null
      }
    }
  }
}

const mapStateToProps = state => ({
 shipback: state.shipback,
 dropoff: state.quotes.dropoff,
 user_token: state.user,
})

const mapDispatchToProps = dispatch => bindActionCreators({ fetchDetailsQuote, setBreadcrumb }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Dropoff)


// WEBPACK FOOTER //
// ./app/javascript/components/components/Dropoff.jsx